import { render, staticRenderFns } from "./virtual-class-description.component.vue?vue&type=template&id=5ce682b3&scoped=true"
import script from "./virtual-class-description.component.ts?vue&type=script&lang=ts&external"
export * from "./virtual-class-description.component.ts?vue&type=script&lang=ts&external"
import style0 from "./virtual-class-description.component.scss?vue&type=style&index=0&id=5ce682b3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce682b3",
  null
  
)

export default component.exports